import GEO_TYPES from './types'
import CloudApi from '../../api/cloudApi'

export const getGeo = () => ({
  type: GEO_TYPES.GET_GEO,
  payload: CloudApi.getGeo(),
})
